export default "__VITE_ASSET__1544368f__"